import { DS_HEIGHT, DS_SPACING_UNITS } from '@calm/evexia-design-tokens';
import { MediaImage } from '@calm/evexia-web-sdk';
import { AccessCodeHeader } from '@rhg/components/access-code-header';
import {
    FullPageFullWidthContainer,
    FullPagePaddedContainer,
    fullPagePaddingPx,
} from '@rhg/components/full-page-container';
import { Box, Theme } from '@rhg/libs/material';
import { ReactNode } from 'react';
import { PackDetailsHeader } from '../header';

interface PackDetailsLayoutProps {
    children?: ReactNode;
    packClass?: string;
    title?: string;
    subtitle?: string;
    imageData?: MediaImage;
}

const styleBackground = {
    background: (theme: Theme) => theme.palette.gradient.backgroundPrimary,
    minHeight: `calc(100dvh - ${DS_HEIGHT.TOOLBAR}px)`,
    pb: DS_SPACING_UNITS.SECTION,
    position: 'relative',
};

export const PackDetailsPaddingPx = fullPagePaddingPx;
export const PackDetailsPaddedContainer = FullPagePaddedContainer;
export const PackDetailsFullWidthContainer = FullPageFullWidthContainer;

export const PackDetailsLayout = ({
    title,
    subtitle,
    imageData,
    children,
}: PackDetailsLayoutProps) => {
    return (
        <Box sx={styleBackground}>
            <AccessCodeHeader />

            <PackDetailsHeader
                title={title}
                subtitle={subtitle}
                imageData={imageData}
            />
            {children}
        </Box>
    );
};
